module.exports = __webpack_public_path__ + "img/logo_block_3.e4c91770.svg";